import { useMutation } from '@tanstack/react-query';

import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApplicationFormContext } from '../../requests/getApplicationFormContext';

export const useApplicationFormContextLoader = (definitionName: string) => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync: loadFormContext, ...rest } = useMutation({
    mutationFn: ({ uuid, formKey }: { uuid: string; formKey: string }) =>
      getApplicationFormContext(constructGet, uuid, definitionName, {
        form: formKey,
      }),
    onError: () => handleError('Could not load form context.'),
  });

  return { loadFormContext, ...rest };
};
